import CustomModal from 'components/Common/CustomModal'
import React, { useState } from 'react'
import { inputStyle } from 'views/Orders/CreateOrder'
import { ReactComponent as Lock } from "../../assets/img/lock.svg"
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import { toast } from 'react-toastify';
import api from 'api';
import FilePicker from 'components/FilePicker/FilePicker';
import { getMediaUrl } from '../../config';


const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 3,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#2ECA45',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 20,
        height: 20,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#DBDDE6',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));


const EditBrandModal = ({ handleEditModal, user, getUsers, loading, setLoading }) => {
    console.log("user brand", user)
    const [data, setData] = useState({
        name: user?.name ?? "",
        email: user?.email ?? "",
        websiteLink: user?.websiteLink ?? "",
    });

    const [enableReward, setEnableReward] = useState(user?.enableReward === true || user?.enableReward === "true");
    const [emailRequire, setEmailRequire] = useState(user?.emailRequire === true || user?.emailRequire === "true");
    const [logoFile, setLogoFile] = useState(null);
    const [fileName, setFileName] = useState(user?.logo ? getMediaUrl(user?.logo) : "");

    const handleEnableReward = (event) => {
        setEnableReward(event.target.checked);
    };

    const handleEmailRequire = (event) => {
        setEmailRequire(event.target.checked);
    };

    const handleChange = (e) => {
        setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleFile = (e) => {
        if (e.target.files[0]) {
            setLogoFile(e.target.files[0]);
            setFileName(URL.createObjectURL(e.target.files[0]));
        }
    };

    const handleDeleteImage = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setFileName("");
        setLogoFile(null);
    };

    const updateBrand = (e) => {
        setLoading(true)
        e.preventDefault();

        if (!data.name) {
            setLoading(false)
            return toast.error("Please enter the brand's name");
        }

        let formData = new FormData();

        for (let key in data) {
            formData.append(key, data[key]);
        }

        // Ensure boolean values are stored correctly as "true" or "false"
        formData.append("enableReward", enableReward.toString());
        formData.append("emailRequire", emailRequire.toString());

        if (logoFile) {
            formData.append("logo", logoFile);
        }

        api('put', `/users/brand/${user._id}`, formData)
            .then((res) => {
                setLoading(false)
                if (res.emailInvitationSent) {
                    toast.success('Brand updated — activation email sent to ' + data.email);
                } else {
                    toast.success('Brand updated successfully');
                }
                getUsers();
                handleEditModal();
            })
            .catch(() => {
                setLoading(false)
                // toast.error("Failed to update brand");
            });
    };

    return (
        <CustomModal heading='Edit Brand' buttonName='Save' handleModal={handleEditModal} handleSave={updateBrand} loading={loading}>
            <div style={inputStyle} className='d-flex justify-content-between align-items-center'>
                <div className='d-flex flex-column'>
                    <span
                        style={{
                            fontWeight: 600,
                            fontSize: '16px',
                            fontFamily: "Outfit",
                            color: '#1C1C1C'
                        }}
                    >Brand ID</span>
                    <span
                        style={{
                            fontWeight: 400,
                            fontSize: '14px',
                            fontFamily: "Outfit",
                            color: '#1C1C1C'
                        }}
                    >{user?._id}</span>
                </div>
                <Lock />
            </div>
            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Brand Name</label><br />
            <input onChange={handleChange} name='name' value={data.name} placeholder='Enter here' style={inputStyle} type="text" />

            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Email <span style={{ fontWeight: 400, fontSize: '13px', color: '#888' }}>(optional — enables portal access)</span></label><br />
            <input onChange={handleChange} name='email' value={data.email} placeholder='No email — portal access disabled' style={inputStyle} type="text" />

            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Brand Domain Name</label><br />
            <input onChange={handleChange} name='websiteLink' value={data.websiteLink} placeholder='Enter here' style={inputStyle} type="text" />
            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Brand Logo</label><br />
            <div style={{ marginBottom: '10px' }}>
                <FilePicker
                    accept="image/*"
                    fileName={fileName}
                    isDelete={true}
                    handleDelete={handleDeleteImage}
                    type="file"
                    onChange={handleFile}
                />
            </div>

            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Require Email on Scan</label><br />
            <div style={inputStyle} className='d-flex justify-content-between align-items-center'>
                <span
                    style={{
                        fontWeight: 400,
                        fontSize: '16px',
                        fontFamily: "Outfit",
                        color: '#1C1C1C'
                    }}
                >Require email for verification</span>
                <IOSSwitch sx={{ m: 1 }} checked={emailRequire} onChange={handleEmailRequire} />
            </div>

            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Enable Reward Center</label><br />
            <div style={inputStyle} className='d-flex justify-content-between align-items-center'>
                <span
                    style={{
                        fontWeight: 400,
                        fontSize: '16px',
                        fontFamily: "Outfit",
                        color: '#1C1C1C'
                    }}
                >Unlock reward center for brand</span>
                <IOSSwitch sx={{ m: 1 }} checked={enableReward} onChange={handleEnableReward} />
            </div>
        </CustomModal>
    )
}

export default EditBrandModal